// extracted by mini-css-extract-plugin
export default {"root":"EnterpriseTitle_root__NxGRJ","text":"EnterpriseTitle_text__hIO4t","icon":"EnterpriseTitle_icon__-sl9U","placeHolderShimmer":"EnterpriseTitle_placeHolderShimmer__k4OPh"};